function UpgradeModal({ setShowModal }) {
  return (
    <div className="box-shadow	rounded flex flex-col mx-6 justify-center items-center max-w-[661px] h-auto relative p-12	 bg-white sm:pb-[70px] sm:px-16 sm:pt-20">
      <div className="absolute top-5 right-5">
        <svg
          onClick={() => setShowModal(false)}
          className=" w-6 h-6 cursor-pointer"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clipRule="evenodd"
          ></path>
        </svg>
      </div>
      <h1 className=" font-semibold text-center text-2xl pb-7">
        We hope you’ve enjoyed your free trial of
        <br />
        GenShare. Please upgrade for premium
        <br />
        access to our generative Studio
      </h1>
      <button
        className={`rounded font-semibold border-2 border-blue text-white px-10 py-3.5 bg-blue hover:bg-white hover:text-blue `}
      >
        Upgrade
      </button>
    </div>
  );
}

export default UpgradeModal;
